module.exports = __webpack_public_path__ + "images/emoji/traffic_light.34e3ad7f9896346f707f.png";